module.exports = __webpack_public_path__ + "static/img/i3.cc410853.svg";